module.exports = __webpack_public_path__ + "img/top_release.d1f1d143.png";